import React, { CSSProperties } from "react";
import { ExpensesData } from "@baseTypes/service/dashboard/IExpensesDashboardService";

import st from './planFactTooltip.module.scss';
import stBase from '../baseTooltipStyles.module.scss';
import { isNumber } from "fp-ts/es6/number";
import { TooltipGrid, TooltipGridCell, TooltipGridRow } from "@infobis/ui-styles-utils";
import { ChartCircle } from "../Circle/ChartCircle";
import { TooltipGridProps } from "@infobis/ui-styles-utils/components/TooltipGrid/TooltipGrid";

const indexes = {
    PLAN: 0,
    FACT: 1
} as const;
type IndexType = typeof indexes[keyof typeof indexes]

interface PlansActualsTooltipProps {
    expenses: ExpensesData[],
    type?: 'accumulative' | 'simple',
    monthIndex: number | undefined,
    className?: string,
    tooltipProps?: TooltipGridProps['tooltipProps']
    content?: TooltipGridProps['content']
    width?: string | number,
    style?: CSSProperties
}

const formatValue = (number: number) => {
    return new Intl.NumberFormat('ru-RU').format(number)
}

const PlanFactTooltip = (props: PlansActualsTooltipProps) => {
    const {
        expenses,
        monthIndex,
        type = 'accumulative',
        tooltipProps,
        className = '',
        content,
        width,
        style = {}
    } = props

    const sumExpensesOf = (planFact: IndexType) =>
        formatValue(expenses.reduce(
            (sumExpenses: number, expense: ExpensesData) =>
                sumExpenses + expense[type].byMonth[monthIndex!][planFact], 0)
        )
    const expenseOf = (idx: IndexType, expense: ExpensesData) =>
        formatValue(expense[type].byMonth[monthIndex!][idx])

    return (
        isNumber(monthIndex)
            ? <TooltipGrid
                style={{ width: width, ...style }}
                ellipsis={false}
                tooltipProps={{ hideOnAnywhereClick: false, trigger: 'static', ...tooltipProps }}
                className={className}
                content={content}
            >
                <TooltipGridRow>
                    <TooltipGridCell/>
                    <TooltipGridCell align={'end'} contentClassName={st.greenText}>План, руб.</TooltipGridCell>
                    <TooltipGridCell align={'end'} contentClassName={st.redText}>Факт, руб.</TooltipGridCell>
                </TooltipGridRow>
                <>
                    {
                        expenses.map((exp, index) => {
                            return (
                                <TooltipGridRow key={exp.title + `-${index}`} >
                                    <TooltipGridCell contentClassName={stBase['cell-content']}>
                                        <ChartCircle
                                            color={exp.color2}
                                            text={exp.title}
                                        />
                                    </TooltipGridCell>
                                    <TooltipGridCell align={'end'}>
                                        {expenseOf(indexes.PLAN, exp)}
                                    </TooltipGridCell>
                                    <TooltipGridCell align={'end'}>
                                        {expenseOf(indexes.FACT, exp)}
                                    </TooltipGridCell>
                                </TooltipGridRow>
                            )
                        })
                    }
                </>
                <TooltipGridRow>
                    <TooltipGridCell>Итого:</TooltipGridCell>
                    <TooltipGridCell align={'end'}>{sumExpensesOf(indexes.PLAN)}</TooltipGridCell>
                    <TooltipGridCell align={'end'}>{sumExpensesOf(indexes.FACT)}</TooltipGridCell>
                </TooltipGridRow>
            </TooltipGrid>
            : <></>
    )
}
export default PlanFactTooltip
